import Styled from 'components/common/Styled';
import type { FC } from 'react';

export const CaptureInfoFormContent: FC = props => {
    return <Styled.FlexBox direction="column" style={{ flex: 1 }} {...props} />;
};
